<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'BscCostDetail',title:'费用管理'}]" />-->
    <Breadtabsheader/>
		<div class="left" style="margin:20px">
			<div class="left3">
				<span class="xunjia">数据总计图表</span>
				<div class="zhongbiao">
					<div class="pie">
						<div class="top">费用总额: <span class="total">{{pieData.pool}}</span>万</div>
						<div class="middle">
							<div class="h-pieChart" id="h_line1Chart" style="width: 5.6rem; height: 4rem;"></div>
						</div>
						<div class="bottom" style="padding-left: 1.2rem;">
							<div class="used">已用:￥{{pieData.cost}}</div>
							<div class="more">剩余:￥{{pieData.settle}}</div>
						</div>
					</div>
					<div class="histogram">
						<div style="font-size: 20px; text-align: center; margin-bottom: 20px;">费用使用情况</div>
						<div class="xiangxi" >
							<div class="x-left" v-if="indx == 1">
							<span class="span1" style="">超低温</span>
							<span class="span2" style="">低温</span>
							<span class="span3" style="background-color: ">药品</span>
							<span class="span4" style="background-color: ">血液</span>
							<span class="span5" style="background-color: ">太阳能疫苗</span>
							<span class="span6" style="background-color: ">疫苗网</span>
							<span class="span7" style="background-color: ">培养箱</span>
							<span class="span8" style="background-color: ">生物安全</span>
						</div>
							<div class="x-left" v-if="indx == 0">
								<p class="company1" style="">青岛海尔生物医疗科技有限公司</p>
								<p class="company2" style="">青岛海尔生物医疗股份有限公司</p>
								<p class="company3" style="background-color: ">青岛海尔生物医疗香港有限公司</p>
							</div>
							<div class="x-right">
								<!-- <el-button style="margin-right: -10px;">分销渠道</el-button>
								<el-button type="primary">产品大类</el-button> -->
								<el-button v-for="(item,index) in qiehuan" :key="index" :class="{'qiehuansq':indx==index}" @click="qiehuans(index)">{{item}}</el-button>
							</div>
						</div>
						<div class="h-histogram" v-show="indx == 1" id="h_histogram1" style="width: 12rem; height: 4rem; margin-left: 1rem;"></div>
						<div class="h-histogram" v-show="indx == 0" id="h_histogram2" style="width: 12rem; height: 4rem; margin-left: 1rem;"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="right" style="padding: 0;padding-bottom: 0rem;margin:0.2rem;">
			<div style="padding: 0.34rem 0.26rem;">
				<!-- <span class="xunjia">询价产品信息</span> -->
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder clear">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="费用编码">
								<el-input v-model="q.costCode" placeholder="模糊搜索">
								</el-input>
							</el-form-item>
							<el-form-item label="使用类型">
								<el-select v-model="q.usedType" placeholder="请选择">
									<el-option label="占用" value="1"></el-option>
									<el-option label="释放" value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="创建时间">
								<el-date-picker :clearable="false" type="date" placeholder="请选择" v-model="q.createDate" @change="createDateChange" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
							</el-form-item>
							<el-form-item class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
								<el-button class="h-btn el-icon-plus h-bggreen" @click="dialogFormVisible = true">新增费用</el-button>
							</el-form-item>
						</div>
					</el-form>
				</div>
			</div>
			
		</div>
		<div class="h-table h-mrt30" v-if="clickActive==1" style="margin: 0.2rem;">
			<el-table max-height="450" ref="multipleTable" stripe :data="tableData2" @selection-change="handleSelectionChange" style="width: 100%" :border="true">
				<el-table-column type="selection" label="全选" width="40">
				</el-table-column>
				<el-table-column type="index" label="#" width="40">
				</el-table-column>
					<el-table-column prop="costType" label="费用类型" :show-overflow-tooltip="true">
					</el-table-column>
				<el-table-column prop="costCode" label="费用编码" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="usedType" label="使用类型" :show-overflow-tooltip="true">
				</el-table-column>
				<!-- <el-table-column prop="disChannels" label="分销渠道" width="100">
				</el-table-column> -->
				<el-table-column prop="costAmount" label="费用金额" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="costState" label="费用状态" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="cdate" label="创建时间" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="80">
					<template slot-scope="scope">
						<el-button type="text" size="small" class="h-tableLink h-btn" @click="chaKan(scope.row)">
							查看
						</el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="chaKan(scope.row)"></span>
						</div> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="h-tableB h-mrt30" style="margin:20px">
				<div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
									@click="outExcel">批量导出
					</el-button>
				</div>
			<div class="h-pagination2">
					<pagination :page="q" @query="query"/>
			</div>
		</div>
		<!-- 驳回弹窗 -->
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 Fei">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>新增费用</h1>
		                <p>New cost</p>
		            </div>
		        </div>
		    </div>
		    <div class="h-formLine h-mrb-38">
				<div class="wrapper wky-wrapper">
					<el-form :model="addCom" ref="formLabelAlign2" :rules="rule" :inline="true" class="top-wrapper demo-ruleForm h-formbLine h-dialogForm">
							<el-form-item label="新增金额" class="h-elformWrap-2 k-elformWrap-2" prop="amount">
								<el-input v-model="addCom.amount"></el-input>
								<!-- <p v-if="bixutian1" class="bixutian">*新增金额不能为空!</p> -->
							</el-form-item>
							<el-form-item label="费用类型" class="h-elformWrap-2 k-elformWrap-2" prop="costType"> 
								<el-select v-model="addCom.costType" placeholder="请选择">
									<el-option label="订单特价" value="2"></el-option>
									<el-option label="工程特价" value="1"></el-option>
								</el-select>
								<!-- <p v-if="bixutian2" class="bixutian">*费用类型不能为空!</p> -->
							</el-form-item>
							<el-form-item label="币种" class="h-elformWrap-2 k-elformWrap-2" prop="currency">
								<el-select v-model="addCom.currency" placeholder="请选择">
									<el-option label="人民币(CNY)" value="CNY"></el-option>
									<el-option label="美元(USD)" value="USD"></el-option>
								</el-select>
								<!-- <p v-if="bixutian3" class="bixutian">*币种不能为空!</p> -->
							</el-form-item>
					</el-form>
					<div class="bottom-wrapper">
						<el-form-item label="备注">
                        <el-input v-model="addCom.comment" placeholder="" style="width:130px;" ></el-input>
                    </el-form-item>
						<!-- <div class="substance">
								<textarea v-model="addCom.comment" name="" id="" style="width: 100%; height: 150px;resize: none; outline: none; border: none;"></textarea>
						</div>
						<div class="outline1 outline"></div>
						<div class="outline2 outline"></div>
						<div class="outline3 outline"></div> -->
					</div>
					<div style="display:flex;justify-content:center;margin-top: 0.2rem; padding: 10px 20px 0.68rem;">
						<el-button class="h-btn h-bBtn h-bgwhite" @click="dialogFormVisible = false">取消</el-button>
						<el-button class="h-btn h-bBtn h-bgblueQ2" @click="comInset('formLabelAlign2')">提交</el-button>
					</div>
				</div>
		   </div>
		</el-dialog>
	</div>
</template>
<script>
    import ss from '../../../api/SystemService'
	export default {
		data() {
			return {
				isFenxiaoqudao:0,
				indx:0,
				qiehuan:['分销渠道','产品大类'],
                bixutian1:false,
                bixutian2:false,
                bixutian3:false,

                //查询属性
                q: {
                    pageSize:10,
                    pageNo:1,
                    total: 0,
                },

                //饼
                pieData: {
                    pool:'',
                    cost:'',
                    settle:'',
                },

				//表单
				all: '全部',
				f: {
                    id:null,
                    fId:null,
                    costCode:null,
                    costType:null,
                    disChannels:null,
                    usedType:null,
                    costState:null,
                    costAmount:null,
                    userCode:null,
                    specialVersion:null,
                    cucode:null,
                    cuname:null,
                    cdate:null,
                    lucode:null,
                    ldate:null,
                    delflag:null,
				},
                //table列表
                tableData: [],
                //操作标志
                optFlag:'save',
                //表格
                multipleSelection: [],
                //当前表信息
                tableData2: [],
                //提示信息
                text: '',
                //提示信息框
                dialogFormVisible2: false,
                //弹框
                dialogFormVisible: false,

                //条形图常量
                tableCDWm01: null,
                tableDWm01: null,
                tableYPm01: null,
                tableXYm01: null,
                tableTYNm01: null,
                tableYMWm01: null,
                tablePYXm01: null,
                tableSWm01: null,
				tableHTm01: null,
				tableHEm01: null,
				tableXGm01: null,

                tableCDWm02: null,
                tableDWm02: null,
                tableYPm02: null,
                tableXYm02: null,
                tableTYNm02: null,
                tableYMWm02: null,
                tablePYXm02: null,
                tableSWm02: null,
				tableHTm02: null,
				tableHEm02: null,
				tableXGm02: null,

                tableCDWm03: null,
                tableDWm03: null,
                tableYPm03: null,
                tableXYm03: null,
                tableTYNm03: null,
                tableYMWm03: null,
                tablePYXm03: null,
                tableSWm03: null,
				tableHTm03: null,
				tableHEm03: null,
				tableXGm03: null,

                tableCDWm04: null,
                tableDWm04: null,
                tableYPm04: null,
                tableXYm04: null,
                tableTYNm04: null,
                tableYMWm04: null,
                tablePYXm04: null,
                tableSWm04: null,
				tableHTm04: null,
				tableHEm04: null,
				tableXGm04: null,

                tableCDWm05: null,
                tableDWm05: null,
                tableYPm05: null,
                tableXYm05: null,
                tableTYNm05: null,
                tableYMWm05: null,
				tablePYXm05: null,
				tableSWm05: null,
				tableHTm05: null,
				tableHEm05: null,
				tableXGm05: null,

                tableCDWm06: null,
                tableDWm06: null,
                tableYPm06: null,
                tableXYm06: null,
                tableTYNm06: null,
                tableYMWm06: null,
                tablePYXm06: null,
                tableSWm06: null,
				tableHTm06: null,
				tableHEm06: null,
				tableXGm06: null,


                tableCDWm07: null,
                tableDWm07: null,
                tableYPm07: null,
                tableXYm07: null,
                tableTYNm07: null,
                tableYMWm07: null,
				tablePYXm07: null,
				tableSWm07: null,
				tableHTm07: null,
				tableHEm07: null,
				tableXGm07: null,

                tableCDWm08: null,
                tableDWm08: null,
                tableYPm08: null,
                tableXYm08: null,
                tableTYNm08: null,
                tableYMWm08: null,
                tablePYXm08: null,
                tableSWm08: null,
				tableHTm08: null,
				tableHEm08: null,
				tableXGm08: null,

                tableCDWm09: null,
                tableDWm09: null,
                tableYPm09: null,
                tableXYm09: null,
                tableTYNm09: null,
                tableYMWm09: null,
                tablePYXm09: null,
                tableSWm09: null,
				tableHTm09: null,
				tableHEm09: null,
				tableXGm09: null,

                tableCDWm10: null,
                tableDWm10: null,
                tableYPm10: null,
                tableXYm10: null,
                tableTYNm10: null,
                tableYMWm10: null,
                tablePYXm10: null,
                tableSWm10: null,
				tableHTm10: null,
				tableHEm10: null,
				tableXGm10: null,

                tableCDWm11: null,
                tableDWm11: null,
                tableYPm11: null,
                tableXYm11: null,
                tableTYNm11: null,
                tableYMWm11: null,
                tablePYXm11: null,
                tableSWm11: null,
				tableHTm11: null,
				tableHEm11: null,
				tableXGm11: null,

                tableCDWm12: null,
                tableDWm12: null,
                tableYPm12: null,
                tableXYm12: null,
                tableTYNm12: null,
                tableYMWm12: null,
                tablePYXm12: null,
                tableSWm12: null,
				tableHTm12: null,
				tableHEm12: null,
				tableXGm12: null,

                addCom: {
                    amount: '',
                    costType: '',
                    currency: '',
                    comment: '',
                },
				clickActive: 1,
				rule:{
					amount: [
						{ required: true, message: '请填写新增金额', trigger: 'blur' }
					],
					costType: [
						{ required: true, message: '请选择费用类型', trigger: 'change' }
					],
					currency: [
						{ required: true, message: '请选择币种', trigger: 'change' }
					]
				}
			}
		},
        created() {
            this.query();
            this.query2();
            this.query3();
        },
        //监听
        watch:{
            dialogFormVisible(val){
                //若关窗，就把资料清空
                if(val==false){
                this.clean();
                }
            },
        },
		methods: {
			qiehuans(index){
				console.log(index)
				this.indx = index;
				console.log("this.indx=="+this.indx)

				if(this.indx==0){
				this.query3();
				}else if(this.indx==1){
					this.query2();
				}
			},
            clean(){

                    this.bixutian1 = false;
                    this.bixutian2 = false;
                    this.bixutian3 = false;

                    this.addCom.amount = '';
                    this.addCom.costType = '';
                    this.addCom.currency = '';
                    this.addCom.comment = '';

                    this.dialogFormVisible = false

                    this.q.costCode = '';
                    this.q.usedType = '';
                    this.q.createDate = '';

                    this.query();

            },

            // bixutian1ch(q){
            //     this.bixutian1 = q?false:true;
            // },
            // bixutian2ch(q){
            //     this.bixutian2 = q?false:true;
            // },
            // bixutian3ch(q){
            //     this.bixutian3 = q?false:true;
            // },
            createDateChange() {
                console.log('createDate', this.q.createDate);
            },

            //查询翻页
            query() {

                // console.log(this.q, "下面表格参数");
                ss.costDetailService.getCostDetailServiceByTimePage(this.q).then(rd => {
                    // console.log(rd, "下面表格");
                    this.q.total = rd.total;

                    // console.log(rd.records, "下面表格数据");
                    // this.tableData2 = rd.records;
                    this.getTable(rd.records);

                });

                var sid = {
                    id : 1
                };

                ss.costDataService.selectById(sid).then(rd => {

                    this.pieData.pool = rd.pool / 10000;
                    this.pieData.cost = rd.cost;
                    this.pieData.settle = rd.settle;

                    this.lineChart1();

                });

            },

            getTable(vw){

                this.tableData2=[];
                //加载表
                for(var ui in vw) {
                    var table =  {
                        id: vw[ui].id,
                        costType: vw[ui].costType==1?'工程特价':vw[ui].costType==2?'订单特价':'',
                        costCode: vw[ui].costCode,
                        usedType: vw[ui].usedType==1?'占用':vw[ui].usedType==2?'释放':'',
                        disChannels: vw[ui].disChannels==1?'内销':vw[ui].disChannels==2?'外销':vw[ui].disChannels==3?'上海直销':'',
                        costAmount: vw[ui].costAmount,
                        costState: vw[ui].costState,//==0?'已取消':vw[ui].costState==1?'预占用':vw[ui].costState==2?'已转化':'',
                        cdate: vw[ui].cdate,
                        //progress: vw[ui].useing==''||vw[ui].useing==null?'0/0':vw[ui].useing,
                        //zongshu: vw[ui].useing==''||vw[ui].useing==null?0:vw[ui].useing.split('/')[1],
                    };
                    this.tableData2.push(table);
                }

            },
          //查询产品大类信息
            query2() {

                var str = {code:"1"};

                ss.specialOfferService.getAmountByStr(str).then(rd => {
                    this.tableCDWm01 = rd[0]; this.tableCDWm02 = rd[1]; this.tableCDWm03 = rd[2];
                    this.tableCDWm04 = rd[3]; this.tableCDWm05 = rd[4]; this.tableCDWm06 = rd[5];
                    this.tableCDWm07 = rd[6]; this.tableCDWm08 = rd[7]; this.tableCDWm09 = rd[8];
                    this.tableCDWm10 = rd[9]; this.tableCDWm11 = rd[10]; this.tableCDWm12 = rd[11];
                    this.tableDWm01 = rd[12]; this.tableDWm02 = rd[13]; this.tableDWm03 = rd[14];
                    this.tableDWm04 = rd[15]; this.tableDWm05 = rd[16]; this.tableDWm06 = rd[17];
                    this.tableDWm07 = rd[18]; this.tableDWm08 = rd[19]; this.tableDWm09 = rd[20];
                    this.tableDWm10 = rd[21]; this.tableDWm11 = rd[22]; this.tableDWm12 = rd[23];
                    this.tableYPm01 = rd[24]; this.tableYPm02 = rd[25]; this.tableYPm03 = rd[26];
                    this.tableYPm04 = rd[27]; this.tableYPm05 = rd[28]; this.tableYPm06 = rd[29];
                    this.tableYPm07 = rd[30]; this.tableYPm08 = rd[31]; this.tableYPm09 = rd[32];
                    this.tableYPm10 = rd[33]; this.tableYPm11 = rd[34]; this.tableYPm12 = rd[35];
                    this.tableXYm01 = rd[36]; this.tableXYm02 = rd[37]; this.tableXYm03 = rd[38];
                    this.tableXYm04 = rd[39]; this.tableXYm05 = rd[40]; this.tableXYm06 = rd[41];
                    this.tableXYm07 = rd[42]; this.tableXYm08 = rd[43]; this.tableXYm09 = rd[44];
                    this.tableXYm10 = rd[45]; this.tableXYm11 = rd[46]; this.tableXYm12 = rd[47];
                    this.tableTYNm01 = rd[48]; this.tableTYNm02 = rd[49]; this.tableTYNm03 = rd[50];
                    this.tableTYNm04 = rd[51]; this.tableTYNm05 = rd[52]; this.tableTYNm06 = rd[53];
                    this.tableTYNm07 = rd[54]; this.tableTYNm08 = rd[55]; this.tableTYNm09 = rd[56];
                    this.tableTYNm10 = rd[57]; this.tableTYNm11 = rd[58]; this.tableTYNm12 = rd[59];
                    this.tableYMWm01 = rd[60]; this.tableYMWm02 = rd[61]; this.tableYMWm03 = rd[62];
                    this.tableYMWm04 = rd[63]; this.tableYMWm05 = rd[64]; this.tableYMWm06 = rd[65];
                    this.tableYMWm07 = rd[66]; this.tableYMWm08 = rd[67]; this.tableYMWm09 = rd[68];
                    this.tableYMWm10 = rd[69]; this.tableYMWm11 = rd[70]; this.tableYMWm12 = rd[71];
                    this.tablePYXm01 = rd[72]; this.tablePYXm02 = rd[73]; this.tablePYXm03 = rd[74];
                    this.tablePYXm04 = rd[75]; this.tablePYXm05 = rd[76]; this.tablePYXm06 = rd[77];
                    this.tablePYXm07 = rd[78]; this.tablePYXm08 = rd[79]; this.tablePYXm09 = rd[80];
                    this.tablePYXm10 = rd[81]; this.tablePYXm11 = rd[82]; this.tablePYXm12 = rd[83];
                    this.tableSWm01 = rd[84]; this.tableSWm02 = rd[85]; this.tableSWm03 = rd[86];
                    this.tableSWm04 = rd[87]; this.tableSWm05 = rd[88]; this.tableSWm06 = rd[89];
                    this.tableSWm07 = rd[90]; this.tableSWm08 = rd[91]; this.tableSWm09 = rd[92];
                    this.tableSWm10 = rd[93]; this.tableSWm11 = rd[94]; this.tableSWm12 = rd[95];
                    console.log(this.tableCDWm10, "CDW");
                    console.log(this.tableDWm10, "DW");
                    console.log(this.tableYPm10, "YP");
                    console.log(this.tableXYm10, "XY");
                    console.log(this.tableTYNm10, "TYN");
                    console.log(this.tableYMWm10, "YMW");
                    console.log(this.tablePYXm10, "PYX");
                    console.log(this.tableSWm10, "SW");
                    this.histogram();
                });

            },
			//查询分销渠道信息
			query3() {

				var str = {code:"1"};

				ss.specialOfferService.getAmountByCompany(str).then(rd => {
					this.tableHTm01 = rd[0]; this.tableHTm02 = rd[1]; this.tableHTm03 = rd[2];
					this.tableHTm04 = rd[3]; this.tableHTm05 = rd[4]; this.tableHTm06 = rd[5];
					this.tableHTm07 = rd[6]; this.tableHTm08 = rd[7]; this.tableHTm09 = rd[8];
					this.tableHTm10 = rd[9]; this.tableHTm11 = rd[10]; this.tableHTm12 = rd[11];
					this.tableHEm01 = rd[12]; this.tableHEm02 = rd[13]; this.tableHEm03 = rd[14];
					this.tableHEm04 = rd[15]; this.tableHEm05 = rd[16]; this.tableHEm06 = rd[17];
					this.tableHEm07 = rd[18]; this.tableHEm08 = rd[19]; this.tableHEm09 = rd[20];
					this.tableHEm10 = rd[21]; this.tableHEm11 = rd[22]; this.tableHEm12 = rd[23];
					this.tableXGm01 = rd[24]; this.tableXGm02 = rd[25]; this.tableXGm03 = rd[26];
					this.tableXGm04 = rd[27]; this.tableXGm05 = rd[28]; this.tableXGm06 = rd[29];
					this.tableXGm07 = rd[30]; this.tableXGm08 = rd[31]; this.tableXGm09 = rd[32];
					this.tableXGm10 = rd[33]; this.tableXGm11 = rd[34]; this.tableXGm12 = rd[35];
					this.companyTable();
				});

			},
            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },

            //新增记录
            comInset(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var addCom = {
						    "amount": this.addCom.amount,
						    "costType": this.addCom.costType,
						    "currency": this.addCom.currency,
						    "comment": this.addCom.comment,
						}
						if(isNaN(this.addCom.amount)){
							this.addCom.amount = '';
						    this.$msg.msge("数据非法，请输入数字");
						}
						if(!isNaN(this.addCom.amount)){
						    if(this.addCom.amount&&this.addCom.costType&&this.addCom.currency!=null){
						        ss.costService.insert(addCom).then(rd => {
						            this.text = rd.msg;
						            // this.dialogFormVisible2 = true;
						            this.$msg.msgs(rd.msg);
						            this.clean();
						        });
						    }
						}
					} else {
						return false;
					}
				});
                

            },

            //导表
            outExcel() {

                //ids
                var cc = [];

                for (var d in this.multipleSelection) {

                    //console.log('select', d);
                    cc.push(this.multipleSelection[d].id);

                }

                //查询参数
                var c = {

                    costCode: this.q.costCode,
                    usedType: this.q.usedType,
                    createDate: this.q.createDate,
                    ids: cc,

                };

                console.log('导表参数', c);

                ss.costDetailService.getCostDetailServiceForExcel(c);

            },

            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log('选择', this.multipleSelection)
            },

            //点击查看详情
            chaKan(item) {

                console.log('行', item)

                this.$router.push({ path:'/cost/Detail' , query: {id: item.id}});

            },

            reset(){
                this.q={
                    pageSize:this.q.pageSize,
                    pageNo:this.q.pageNo,
                    total:this.q.total
                };
                this.query();
            },

			onSubmit() {
				// console.log('submit!');
			},
			histogram() {
				let histogram = this.$echarts.init(document.getElementById('h_histogram1'))
				let option = {
					tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        }
					    },
					    grid: {
					        left: '3%',
					        right: '30%',
					        bottom: '20%',
					        containLabel: true
					    },
					    yAxis:  {
					        type: 'value',
					    },
					    xAxis: {
					        type: 'category',
					        data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月',]
					    },
					    series: [
					        {
					            name: '超低温',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [
					                {value:this.tableCDWm01}, {value:this.tableCDWm02},
                                    {value:this.tableCDWm03}, {value:this.tableCDWm04},
                                    {value:this.tableCDWm05}, {value:this.tableCDWm06},
                                    {value:this.tableCDWm07}, {value:this.tableCDWm08},
                                    {value:this.tableCDWm09}, {value:this.tableCDWm10},
                                    {value:this.tableCDWm11}, {value:this.tableCDWm12},
                                ],
					            //data: [8969, 11902, 13476, 5348, 14337, 8708, 10434, 10355, 6180, 9738, 13758, 4770],
								itemStyle: {
									normal:{color:'#5BA9FE'}
								}
					        },
					        {
					            name: '低温',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [
					                {value:this.tableDWm01}, {value:this.tableDWm02},
                                    {value:this.tableDWm03}, {value:this.tableDWm04},
                                    {value:this.tableDWm05}, {value:this.tableDWm06},
                                    {value:this.tableDWm07}, {value:this.tableDWm08},
                                    {value:this.tableDWm09}, {value:this.tableDWm10},
                                    {value:this.tableDWm11}, {value:this.tableDWm12},
                                ],
					            //data: [{value:this.tableCDWm10}, 3463, 5329, 4911, 3494, 6132, 4130, 6113, 8575, 5348, 2696, 6158],
								itemStyle: {
									normal:{color:'#EDE262'}
								}
					        },
					        {
					            name: '药品',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [
					                {value:this.tableYPm01}, {value:this.tableYPm02},
                                    {value:this.tableYPm03}, {value:this.tableYPm04},
                                    {value:this.tableYPm05}, {value:this.tableYPm06},
                                    {value:this.tableYPm07}, {value:this.tableYPm08},
                                    {value:this.tableYPm09}, {value:this.tableYPm10},
                                    {value:this.tableYPm11}, {value:this.tableYPm12},
                                ],
					            //data: [{value:this.tableCDWm10}, 3613, 4523, 5624, 3837, 5852, 3825, 3344, 3815, 5452, 5625, 4535],
								itemStyle: {
									normal:{color:'#8BA8F4'}
								}
					        },
					        {
					            name: '血液',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [
					                {value:this.tableXYm01}, {value:this.tableXYm02},
                                    {value:this.tableXYm03}, {value:this.tableXYm04},
                                    {value:this.tableXYm05}, {value:this.tableXYm06},
                                    {value:this.tableXYm07}, {value:this.tableXYm08},
                                    {value:this.tableXYm09}, {value:this.tableXYm10},
                                    {value:this.tableXYm11}, {value:this.tableXYm12},
                                ],
					            //data: [{value:this.tableCDWm10}, 3020, 3363, 4137, 3986, 5954, 8731, 5868, 8586, 7345, 5799, 9807],
								itemStyle: {
									normal:{color:'#71D5EF'}
								}
					        },
					        {
					            name: '太阳能疫苗',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [
					                {value:this.tableTYNm01}, {value:this.tableTYNm02},
                                    {value:this.tableTYNm03}, {value:this.tableTYNm04},
                                    {value:this.tableTYNm05}, {value:this.tableTYNm06},
                                    {value:this.tableTYNm07}, {value:this.tableTYNm08},
                                    {value:this.tableTYNm09}, {value:this.tableTYNm10},
                                    {value:this.tableTYNm11}, {value:this.tableTYNm12},
                                ],
					            //data: [{value:this.tableCDWm10}, 4903, 3003, 3631, 3251, 3219, 3603, 4287, 4107, 3510, 4074, 3278],
								itemStyle: {
									normal:{color:'#C490C0'}
								}
					        },
							{
							    name: '疫苗网',
							    type: 'bar',
								barWidth: '20%',
							    stack: '总量',
					            data: [
					                {value:this.tableYMWm01}, {value:this.tableYMWm02},
                                    {value:this.tableYMWm03}, {value:this.tableYMWm04},
                                    {value:this.tableYMWm05}, {value:this.tableYMWm06},
                                    {value:this.tableYMWm07}, {value:this.tableYMWm08},
                                    {value:this.tableYMWm09}, {value:this.tableYMWm10},
                                    {value:this.tableYMWm11}, {value:this.tableYMWm12},
                                ],
							    //data: [{value:this.tableCDWm10}, 8849, 6540, 7855, 6074, 2307, 5197, 3608, 3208, 2432, 5408, 4565],
								itemStyle: {
									normal:{color:'#90C31E'}
								}
							},
							{
							    name: '培养箱',
							    type: 'bar',
								barWidth: '20%',
							    stack: '总量',
					            data: [
					                {value:this.tablePYXm01}, {value:this.tablePYXm02},
                                    {value:this.tablePYXm03}, {value:this.tablePYXm04},
                                    {value:this.tablePYXm05}, {value:this.tablePYXm06},
                                    {value:this.tablePYXm07}, {value:this.tablePYXm08},
                                    {value:this.tablePYXm09}, {value:this.tablePYXm10},
                                    {value:this.tablePYXm11}, {value:this.tablePYXm12},
                                ],
							    //data: [{value:this.tableCDWm10}, 5012, 7402, 6455, 7658, 8498, 7594, 8218, 7627, 9593, 5331, 5922],
								itemStyle: {
									normal:{color:'#4FC3C0'}
								}
							},
							{
							    name: '生物安全',
							    type: 'bar',
								barWidth: '20%',
							    stack: '总量',
					            data: [
					                {value:this.tableSWm01}, {value:this.tableSWm02},
                                    {value:this.tableSWm03}, {value:this.tableSWm04},
                                    {value:this.tableSWm05}, {value:this.tableSWm06},
                                    {value:this.tableSWm07}, {value:this.tableSWm08},
                                    {value:this.tableSWm09}, {value:this.tableSWm10},
                                    {value:this.tableSWm11}, {value:this.tableSWm12},
                                ],
							    //data: [{value:this.tableCDWm10}, 5042, 4878, 5322, 4057, 3991, 5616, 5834, 4512, 3146, 3637, 5529],
								itemStyle: {
									normal:{color:'#507BD7'}
								}
							}
					    ]
				}
				histogram.setOption(option);
			},
			companyTable() {
				let histogram1 = this.$echarts.init(document.getElementById('h_histogram2'))
				let option = {
					tooltip : {
						trigger: 'axis',
						axisPointer : {            // 坐标轴指示器，坐标轴触发有效
							type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '30%',
						bottom: '20%',
						containLabel: true
					},
					yAxis:  {
						type: 'value',
					},
					xAxis: {
						type: 'category',
						data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月',]
					},
					series: [
						{
							name: '青岛海尔生物医疗科技有限公司',
							type: 'bar',
							barWidth: '20%',
							stack: '总量',
							data: [
								{value:this.tableHTm01}, {value:this.tableHTm02},
								{value:this.tableHTm03}, {value:this.tableHTm04},
								{value:this.tableHTm05}, {value:this.tableHTm06},
								{value:this.tableHTm07}, {value:this.tableHTm08},
								{value:this.tableHTm09}, {value:this.tableHTm10},
								{value:this.tableHTm11}, {value:this.tableHTm12},
							],
							//data: [{value:this.tableCDWm10}, 5042, 4878, 5322, 4057, 3991, 5616, 5834, 4512, 3146, 3637, 5529],
							itemStyle: {
								normal:{color:'#C490C0'}
							}
						},
						{
							name: '青岛海尔生物医疗股份有限公司',
							type: 'bar',
							barWidth: '20%',
							stack: '总量',
							data: [
								{value:this.tableHEm01}, {value:this.tableHEm02},
								{value:this.tableHEm03}, {value:this.tableHEm04},
								{value:this.tableHEm05}, {value:this.tableHEm06},
								{value:this.tableHEm07}, {value:this.tableHEm08},
								{value:this.tableHEm09}, {value:this.tableHEm10},
								{value:this.tableHEm11}, {value:this.tableHEm12},
							],
							//data: [{value:this.tableCDWm10}, 5042, 4878, 5322, 4057, 3991, 5616, 5834, 4512, 3146, 3637, 5529],
							itemStyle: {
								normal:{color:'#90C31E'}
							}
						},
						{
							name: '青岛海尔生物医疗香港有限公司',
							type: 'bar',
							barWidth: '20%',
							stack: '总量',
							data: [
								{value:this.tableXGm01}, {value:this.tableXGm02},
								{value:this.tableXGm03}, {value:this.tableXGm04},
								{value:this.tableXGm05}, {value:this.tableXGm06},
								{value:this.tableXGm07}, {value:this.tableXGm08},
								{value:this.tableXGm09}, {value:this.tableXGm10},
								{value:this.tableXGm11}, {value:this.tableXGm12},
							],
							//data: [{value:this.tableCDWm10}, 5042, 4878, 5322, 4057, 3991, 5616, 5834, 4512, 3146, 3637, 5529],
							itemStyle: {
								normal:{color:'#4FC3C0'}
							}
						}
					]
				}
				histogram1.setOption(option);
			},
			lineChart1(){
				let lineChart1 = this.$echarts.init(document.getElementById('h_line1Chart'));
				let option = {
			        /* title : {
			            text: '下单金额',
			            x:'center',
			            y:'70%'
			        }, */
			        tooltip : {
			            trigger: 'item',
			            formatter: "{b} ({d}%)"
			        },
			        legend: {
					    show:false
			        },
			        series : [
			            {
			                //name: '下单金额',
			                //barWidth: '50%',
			                type: 'pie',
			                radius : '40%',
			                center: ['50%', '40%'],
			                data:[
			                    {value:this.pieData.cost, name:'已用：￥'+this.pieData.cost},
			                    {value:this.pieData.settle, name:'剩余：￥'+this.pieData.settle},
			                ],
			                itemStyle: {
			                    normal:{
			                        color: function(params) {
			                            let colorList = [
											"#fec10c",
			                                "#5ba9fe"
			                            ];
			                            return colorList[params.dataIndex];
			                        },
			                    },
			                    emphasis: {
			                        shadowBlur: 10,
			                        shadowOffsetX: 0,
			                        shadowColor: 'rgba(0, 0, 0, 0.5)'
			                    }
			                }
			            }
			        ]
				}
				lineChart1.setOption(option);
			},
		},
		mounted(){
			this.lineChart1();
			this.histogram();
			this.companyTable()
		}
	}
</script>
<style scoped>
	.qiehuansq{
		background: #409EFF;
		color: #fff;
	}
	.clear::after {
		content: '';
		display: block;
		width: 0;
		height: 0;
		clear: both;
	}
	.left {
		background-color: rgb(255, 255, 255);
		padding: 0.22rem 0.26rem;
		border: 1px solid #E2E2E2;
	}
	.xunjia {
		color: #0e75e9;
		display: inline-block;
		padding-left: 10px;
		border-left: 5px solid #0e75e9;
		font-weight: bold;
		font-size: .18rem;
		margin-bottom: 20px;
	}
	.zhongbiao {
		display: flex;
	}
	.pie {
		width: 30%;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		text-align: center;
		margin-right: 30px;
	}
	.top {
		font-size: 20px;
	}
	.top>.total {
		color: #5BA9FE;
		font-weight: bold;
		font-size: 22px;
	}
	.bottom {
		display: flex;
		flex-direction: column;
		padding-left: 1.5rem;
		text-align: left;
	}
	.used::before {
		content: '';
		width: 24px;
		display: inline-block;
		height: 16px;
		background-color: #fec10c;
		margin-right: 20px;
	}
	.used {
		height: 16px;
		line-height: 16px;
		margin-bottom: 14px;
		font-size: 14px;
	}
	.more::before {
		content: '';
		width: 24px;
		display: inline-block;
		height: 16px;
		background-color:#5ba9fe;
		margin-right: 20px;
	}
	.more {
		height: 16px;
		line-height: 16px;
		margin-bottom: 14px;
		font-size: 14px;
	}
	.middle {
		width: 350px;
		height: 250px;
	}
	.h-rowCon {
		position: absolute;
		top: -100px;
		left: -220px;
	}
	.histogram {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	.xiangxi {
		display: flex;
		flex-direction: row;
	}
	.x-left {
		width: 70%;
		flex-shrink: 0;
	}
	.x-left>span {
		width: 20%;
		float: left;
		margin-bottom: 10px;
		font-size: 0.14rem;
	}
	.x-left>span::before {
		width: 0.3rem;
		height: 0.2rem;
		display: inline-block;
		content: '';
		margin-bottom: -0.08rem;
		margin-right: 0.1rem;
	}
	.x-left>p {
		width: 35%;
		float: left;
		margin-bottom: 10px;
		font-size: 0.14rem;
	}
	.x-left>p::before {
		width: 0.3rem;
		height: 0.2rem;
		display: inline-block;
		content: '';
		margin-bottom: -0.08rem;
		margin-right: 0.1rem;
	}
	.x-left .span1::before {
		background-color: #5BA9FE;
	}
	.x-left .span2::before {
		background-color: #5BA9FE;
	}
	.x-left .span3::before {
		background-color: #8BA8F4;
	}
	.x-left .span4::before {
		background-color: #71D5EF;
	}
	.x-left .span5::before {
		background-color: #C490C0;
	}
	.x-left .span6::before {
		background-color: #90C31E;
	}
	.x-left .span7::before {
		background-color: #4FC3C0;
	}
	.x-left .span8::before {
		background-color: #507BD7;
	}

	.x-left .company1::before {
		background-color: #C490C0;
	}
	.x-left .company2::before {
		background-color: #90C31E;
	}
	.x-left .company3::before {
		background-color: #4FC3C0;
	}

	.x-right {
		flex-grow: 1;
	}
	.right {
		background-color: rgb(255, 255, 255);
		padding: 40px 45px 60px;
		border: 1px solid #E2E2E2;
	}
	.h-formBtnOut2 {
		float: right;
	}
	.new-add {
		background: #24B5B8;
		color: #FFF;
		border: none;
	}
	.h-table {
		margin-top: 0;
	}
	.enter {
		text-align: center;
	}
	.enter .el-button {
		padding: 18px 43px;
	}
	/* 弹出窗 */
	.wrapper {
		display: flex;
		flex-direction: column;
	}
	.top-wrapper{
		flex-shrink: 0;
	}
	.h-formbLine .el-form-item__content .el-input__inner {
	 border-radius: 0;
	 background: transparent;
	 color: #868686;
	 border: 0;
	 border-bottom: 1px solid #dedede;
	 height: 0.29rem;
	 line-height: 0.28rem;
	 padding-left: 0.15rem;
	}
	.bottom-wrapper {
		flex-grow: 1;
		display: flex;
		flex-direction: row;
		position: relative;
	}
	.outline {
		width: 80%;
		position: absolute;
		left: 90px;
		border-bottom: 1px solid #ccc;
	}
	.outline1 {
		top: 50px;
	}
	.outline2 {
		top: 100px;
	}
	.outline3 {
		top: 149px;
	}
	.remark {
		width: 85px;
		height: 50px;
		font-size: 0.18rem;
		line-height: 50px;
		padding-right: 14px;
		text-align: right;
	}
	.remark::before {
		content: '';
		margin-right: 10px;
	}
	.substance {
		width: 90%;
	}
	.h-btn1 {
		width: 107px;
	}
	.h-dialogForm {
		padding: 0;
	}
	 .bixutian{
        color: red;
		font-size: 0.12rem;
    }
</style>
<style>
	.Fei .h-elformWrap-2 .el-form-item__label{
		width: 46%;
	}
	.Fei .h-elformWrap-2 .el-form-item__content{
		width: 54%;
	}
	.h-formbLine2 .el-form-item__label {
		width: 26% !important;
	}

	.h-formbLine2 .el-form-item__content {
		width: 74% !important;
	}
	.wky-wrapper .el-form {
		padding: 0.54rem 0.28rem 0 0.25rem;
	}
	.wky-wrapper .el-form-item {
		width: 50% !important;
	}
</style>
